import React from 'react'
import Switch from '../../InputSwitch'
import TipIcon from '../../TipIcon'

import { Wrapper, LabelColumn, Label, SubLabel, SwitchColumn } from './styles'

const ListSwitchItem = ({
  tip,
  name,
  value,
  label,
  subLabel,
  inputName,
  onChange,
  disabled,
}) => (
  <Wrapper>
    <LabelColumn>
      <Label>
        {label} {tip && <TipIcon tip={tip} />}
      </Label>
      <SubLabel>{subLabel}</SubLabel>
    </LabelColumn>
    <SwitchColumn>
      <Switch
        name={inputName || name}
        onChange={onChange}
        value={value}
        disabled={disabled}
      />
    </SwitchColumn>
  </Wrapper>
)

export default ListSwitchItem
